import React from 'react'
import CatalogoReport from 'entity/Rodada/Relatorios/CatalogoReport'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, MenuItem, Select } from '@mui/material'

import { ReactComponent as BrazilFlag } from '../../../../../src/util/br.svg'
import { ReactComponent as SpainFlag } from '../../../../../src/util/es.svg'
import CatalogoReportES from 'entity/Rodada/Relatorios/CatalogoReportES'
import { usePainelContext } from './PainelContext'


export default function Catalogo(props) {
    const [selectedOption, setSelectedOption] = React.useState('pt')
    const { inscricoes : participantes } = usePainelContext();
    const handleOptionChange = (event) => setSelectedOption(event.target.value)

    const cancelarOnclick = () => props.setOpen(false)

    const imprimirCatalogo = () => props.setOpen(true)

    const todosOnClick = async () => {
        if (selectedOption === 'pt') {
            new CatalogoReport({ rodada: props.rodada, inscritos: participantes }).generate()
        } else if (selectedOption === 'es') {
            new CatalogoReportES({ rodada: props.rodada, inscritos: participantes }).generate()
        }
        cancelarOnclick()
    }

    const presenteSaiuOnClick = async () => {
        let participantesPresenteSaiu = participantes.filter(p => p.statusEvento === "SAIU" || p.statusEvento === "PRESENTE")

        if (selectedOption === 'pt') {
            new CatalogoReport({ rodada: props.rodada, inscritos: participantesPresenteSaiu }).generate()
        } else if (selectedOption === 'es') {
            new CatalogoReportES({ rodada: props.rodada, inscritos: participantesPresenteSaiu }).generate()
        }
        cancelarOnclick()
    }

    return (
        <>
            <Button
                style={{ width: 150 }}
                onClick={() => {
                    imprimirCatalogo()
                }}
            >
                Catálogo
            </Button>

            <Dialog open={props.open} keepMounted onClose={() => cancelarOnclick()}>
                <DialogTitle>{"Imprimir "}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {`Selecione "Presente/Saiu" para extrair somente inscrições do status Presente ou Saiu, ou selecione "Todos" ou "Cancelar"`}
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <FormControl>
                        <Select
                            value={selectedOption}
                            onChange={handleOptionChange}
                            displayEmpty
                            inputProps={{ 'aria-label': 'Select an option' }}
                            sx={{
                                "& .MuiOutlinedInput-notchedOutline": { border: 0 },
                                "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
                            }}
                        >
                            <MenuItem value="pt" disabled>
                                Idioma
                            </MenuItem>
                            <MenuItem value="pt">
                                <BrazilFlag style={{ height: '1em' }} />
                                <span style={{ marginLeft: '0.5em' }}>Português</span>
                            </MenuItem>
                            <MenuItem value="es">
                                <SpainFlag style={{ height: '1em' }} />
                                <span style={{ marginLeft: '0.5em' }}>Español</span>
                            </MenuItem>
                        </Select>
                    </FormControl>

                    <div style={{ display: 'flex', gap: '10px' }}>
                        <Button onClick={todosOnClick}>Todos</Button>
                        <Button onClick={presenteSaiuOnClick}>Presente/Saiu</Button>
                        <Button onClick={cancelarOnclick}>Cancelar</Button>
                    </div>
                </DialogActions>
            </Dialog >
        </>
    )
}